import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GetAchPaymentByIdQuery, IAchPayment, IAchPaymentInput, SaveAchPaymentMutation } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { AchPaymentApiService } from '../ach-payment-api.service';

@Injectable({
    providedIn: 'root'
  })
  export class AchPaymentGqlService implements AchPaymentApiService {

    constructor(
      private readonly apollo: Apollo
    ) { }
  
    public getAchPayment(achPaymentId: string): Observable<IAchPayment> {
     
      return this.apollo
        .query<{ achPayment: IAchPayment }>({
          query: GetAchPaymentByIdQuery,
          variables: {
            achPaymentId: achPaymentId
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
            map(result => result.data.achPayment)
        );
    }

    public saveAchPayment(achPayment: IAchPaymentInput): Observable<any> {
      
      return this.apollo
        .mutate({
          mutation: SaveAchPaymentMutation,
          variables : {
            achPayment: achPayment,
            
          }
        })
        .pipe(map(result => (result.data as any)['saveAchPayment'].id as string));
    }

  }